// src/theme/tokens/breakpoints.js
// Source of truth for Figma breakpoint tokens

export const breakpoints = {
  sm: 640,  // breakpoint-s
  md: 768,  // breakpoint-m
  lg: 1024, // breakpoint-l
  xl: 1280, // breakpoint-xl
};

